const getNormalizedFileExtension = (filename: string) => {
  const dotIndex = filename.lastIndexOf(".");

  if (dotIndex < 0) {
    return "";
  }

  return filename.slice(dotIndex).toLowerCase();
};

const matchesAcceptToken = (file: File, token: string) => {
  const normalizedToken = token.trim().toLowerCase();

  if (!normalizedToken) {
    return false;
  }

  if (normalizedToken.startsWith(".")) {
    return getNormalizedFileExtension(file.name) === normalizedToken;
  }

  if (normalizedToken.endsWith("/*")) {
    const mimePrefix = normalizedToken.slice(0, -1);
    return file.type.toLowerCase().startsWith(mimePrefix);
  }

  return file.type.toLowerCase() === normalizedToken;
};

export const checkAcceptedFileType = (
  file: File,
  acceptFileTypes?: string[],
): {
  status: boolean;
  message: string;
} => {
  const normalizedAcceptFileTypes = (acceptFileTypes || []).filter((type) => {
    return type.trim() !== "";
  });

  if (normalizedAcceptFileTypes.length === 0) {
    return {
      status: true,
      message: "",
    };
  }

  const isAccepted = normalizedAcceptFileTypes.some((type) => {
    return matchesAcceptToken(file, type);
  });

  return {
    status: isAccepted,
    // message: isAccepted
    //   ? ""
    //   : `Attachment type is not allowed. Accepted file types: ${normalizedAcceptFileTypes.join(
    //       ", ",
    //     )}`,
    message: isAccepted
      ? ""
      : `Attachment type is not allowed.`,
  };
};
